import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const WEEK_LABEL_MIN_WIDTH = "150px";

export const useVaultMeetingsToolbarStyles = makeStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
  },
  weekLabel: {
    minWidth: WEEK_LABEL_MIN_WIDTH,
    textAlign: "center",
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.ink,
  },
  button: {
    color: projectIqTokens.ink2,
    fontFamily: projectIqTokens.fontFamily,
    fontWeight: designTokens.fontWeight.semibold,
    borderRadius: designTokens.borderRadius.md,
  },
  spacer: {
    flex: 1,
  },
  summary: {
    fontSize: designTokens.fontSize["2xs"],
    color: projectIqTokens.muted,
  },
});
